<template>
  <div>
    <ActionBar>
      <el-button slot="action" type="danger" plain @click="cancel">
        ยกเลิก
      </el-button>
      <el-button slot="action" type="primary" @click="confirm">
        ชำระเงิน
      </el-button>
      <ActionBarTitle>แลกเปลี่ยน</ActionBarTitle>
    </ActionBar>

    <PageContainer>
      <AppContainer>
        <GoldPriceCompact :style="{ marginBottom: '1rem' }"></GoldPriceCompact>

        <el-card header="รายละเอียดลูกค้า" :style="{ marginBottom: '1.5rem' }">
          <ClientProfile :data="customer" @select="selectCustomer" @add="addCustomer"></ClientProfile>
        </el-card>

        <template v-if="customer">
          <el-card :style="{ marginBottom: '1.5rem' }">
            <el-form label-width="8rem">
              <el-row type="flex" :gutter="16" :style="{ flexWrap: 'wrap' }">
                <el-col :sm="12">
                  <el-form-item label="วันที่แลกเปลี่ยน">
                    <el-date-picker v-model="form.date" :style="{ width: '100%' }"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :sm="12">
                  <el-form-item label="เลขที่ใบรับประกัน">
                    <el-input v-model="form.warrantyCardNo"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="รูปแบบการจ่าย" label-width="8rem">
                <el-radio-group v-model="form.type">
                  <el-radio label="full">
                    จ่ายเต็มจำนวน (ลดค่ากำเหน็จ
                    <el-input v-model="form.store.discount" type="number" min="0" max="100" :style="{ width: '5em' }"
                      :class="elementUiStyles.numberInput" :disabled="form.type !== 'full'"></el-input>
                    %)
                  </el-radio>
                  <el-radio label="inst">ราคาผ่อน</el-radio>
                  <el-radio label="mix">จ่ายผสม</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </el-card>

          <ActionBar :style="{
              backgroundColor: 'transparent',
              marginBottom: '1rem',
              padding: '0',
              minHeight: 'auto',
              position: 'static'
            }">
            <el-button slot="action" type="primary" plain icon="el-icon-plus" @click="addStoreItem">
              เพิ่มรายการ
            </el-button>
            <h1 :style="{ margin: '0' }">ทองของร้าน</h1>
          </ActionBar>

          <el-card :style="{ marginBottom: '1.5rem' }">
            <StoreGold :items="form.store.items" :discount="Number(form.store.discount) / 100"
              @remove="removeStoreItem"></StoreGold>
          </el-card>

          <ActionBar :style="{
              backgroundColor: 'transparent',
              marginBottom: '1rem',
              padding: '0',
              minHeight: 'auto',
              position: 'static'
            }">
            <el-button slot="action" type="primary" plain icon="el-icon-plus" @click="addCustomerItem">
              เพิ่มรายการ
            </el-button>
            <h1 :style="{ margin: '0' }">ทองลูกค้า</h1>
          </ActionBar>

          <el-card :style="{ marginBottom: '1.5rem' }">
            <CustomerGold :items="form.customer.items" @remove="removeCustomerItem"></CustomerGold>
          </el-card>

          <el-card>
            <el-form>
              <el-form-item>
                <span slot="label" :class="requiresNote && $style.isRequired">หมายเหตุ</span>
                <el-input v-model="form.note" type="textarea" :autosize="{ minRows: 3 }"></el-input>
              </el-form-item>
            </el-form>
          </el-card>
        </template>
      </AppContainer>
    </PageContainer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
  ActionBar,
  ActionBarTitle,
  //ActionBarButton
} from '@/components/ui/action-bar'
import { AppContainer } from '@/components/ui/container'
import { PageContainer } from '@/components/page/page-container'
import { ClientProfile } from '@/components/page/client-profile'
import { CustomerGold } from '@/components/page/customer-gold'
import { StoreGold } from '@/components/page/store-gold'
import { GoldPriceCompact } from '@/components/page/gold-price-compact'
import { useLoading } from '../../use/loading'

export default {
  components: {
    ActionBar,
    ActionBarTitle,
    //ActionBarButton,
    AppContainer,
    PageContainer,
    ClientProfile,
    CustomerGold,
    StoreGold,
    GoldPriceCompact
  },

  computed: {
    ...mapGetters('trade', ['customer', 'form', 'requiresNote'])
  },

  async created() {
    let loading

    try {
      await this.fetchGoldPrice()

      if (!this.form) {
        loading = useLoading()

        await this.loadCart()
      }

      this.$watch('form.type', value => {
        if (value && value !== 'full') {
          this.form.store.discount = '0'
        }
      })
    } catch (err) {
      this.$notify.error(err.message)
    } finally {
      if (loading) loading.close()
    }
  },

  methods: {
    ...mapActions('trade', [
      'reset',
      'addCustomerItem',
      'removeCustomerItem',
      'addStoreItem',
      'removeStoreItem',
      'validateForm',
      'loadCart',
      'updateCart'
    ]),

    ...mapActions('goldPrice', { fetchGoldPrice: 'fetch' }),

    cancel() {
      this.$confirm(
        'ต้องการที่จะยกเลิกหรือไม่ ข้อมูลต่างๆ ที่กรอกไว้จะหายไป',
        'ยกเลิก',
        {
          confirmButtonText: 'ยกเลิก',
          cancelButtonText: 'ไม่',
          type: 'warning'
        }
      ).then(async () => {
        const loading = useLoading()

        try {
          await this.reset()
          this.$notify.success('ยกเลิกการแลกเปลี่ยนเรียบร้อย')
          this.$router.push({ name: 'Home' })
        } catch (err) {
          this.$notify.error(err.message)
        } finally {
          loading.close()
        }
      })
    },

    async confirm() {
      if (!this.customer) {
        return this.$message.warning({
          message: 'เลือกลูกค้า'
        })
      }

      try {
        await this.validateForm()

        const loading = useLoading()

        try {
          await this.updateCart()

          this.$notify.success('บันทึกข้อมูลเรียบร้อย')

          this.$router.push({
            name: 'TradeCreatePayment'
          })
        } catch (err) {
          this.$notify.error(err.message)
        } finally {
          loading.close()
        }
      } catch (err) {
        this.$message.warning({
          message: 'กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง'
        })
      }
    },

    selectCustomer() {
      this.$router.push({
        name: 'CustomerSelect',
        query: { ref: 'trade' }
      })
    },

    addCustomer() {
      this.$router.push({
        name: 'CustomerCreate',
        query: { ref: 'trade' }
      })
    }
  }
}
</script>

<style lang="scss" module>
.isRequired {
  &::before {
    content: '**';
    color: $--color-danger;
    margin-right: 0.25rem;
  }
}
</style>

<style
  src="@/assets/scss/modules/element-ui.module.scss"
  lang="scss"
  module="elementUiStyles"
></style>

<style
  src="@/assets/scss/modules/utilities.module.scss"
  lang="scss"
  module="utilStyles"
></style>
